import _ from "lodash";

// Type de work item (fonctionnalité, anomalie…) : ses actions sont générées à la création à partir du modèle, dans l'ordre
export const entity = {
    name: 'WorkItemType',
    facets: ['codeName'],
    fields: [
        {path: 'actionTemplate', type: 'ActionType', link: 'MTM', nullable: true},
        {path: 'status', type: 'Status'},
    ],
    filters: [
        {
            name: 'byStatus',
            path: "status",
            object: "Status",
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const status = _.get(context, 'data.status.id');
                return status ? {status: status} : {};
            }
        },
        {
            name: 'onlyActive',
            isDefault: false,
            query: function() {
                return {status: 'actif'}
            }
        }
    ]
}

export const module_ = {
    object: 'WorkItemType',
    category: {
        path: 'configuration',
        icon: 'settings'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: ['code', 'name', 'actionTemplate', {path: 'status', initiallyNotVisible: true}],
        form: [
            {path: 'code', placeholder: 'renseigner un code unique', noSpaces: true},
            {path: 'name', placeholder: 'renseigner un nom unique'},
            {path: 'actionTemplate', display: 'fullName', placeholder: 'sélectionner les actions à générer, dans l’ordre'},
            {path: 'status', type: 'toggle', default: {id: 'actif'}}
        ]
    },
    filters: ['byStatus']
}
